import _ from 'lodash';
import { CustomRenderers } from 'pages/ListManagement/types';

export const NumberRenderer = ({ allowEmpty, ...props }: CustomRenderers) => {
    const { value } = props;

    if (allowEmpty && value === '') props.TD.className = '';
    else if (value === '' || !_.isFinite(Number(value))) props.TD.className = 'htInvalid';
    else props.TD.className = '';

    return <div>{props.value}</div>;
};

export const AutoCompleteRenderer = ({ list, allowEmpty, ...props }: CustomRenderers) => {
    const { value } = props;

    if (allowEmpty && value === '') props.TD.className = '';
    else if (list) props.TD.className = list.includes(value as string) ? '' : 'htInvalid';

    return <div>{props.value}</div>;
};

export const CustomIntervalRenderer = ({ allowEmpty, ...props }: CustomRenderers) => {
    const { value } = props;
    const min = props.min;
    const max = props.max;

    if (allowEmpty && value === '') props.TD.className = '';
    else if (value === '') {
        props.TD.className = 'htInvalid';
    } else if (typeof min === 'number' && value < min) {
        props.TD.className = 'htInvalid';
    } else if (typeof max === 'number' && value > max) {
        props.TD.className = 'htInvalid';
    }

    return <div>{props.value}</div>;
};
